var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.instructors,"fields":_vm.instructorFields,"empty-text":_vm.$t('general.no_results_found'),"empty-filtered-text":_vm.$t('general.no_results_found'),"show-empty":"","no-provider-paging":""}})}
var staticRenderFns = []

export { render, staticRenderFns }